export default __webpack_public_path__ + "static/media/path2.0daa681c.svg";